import net from '../../../../net/net';
import oxocard from '../../../../oxocard/oxocard';
import PopupComponent from '../popup-component';
import Helper from '../../helper';
import template from './template';
import { SET_CARD_NAME_PATH, GET_UNIQUE_NAME_PATH, ERROR_NO_HMAC_CLIENT } from '../../../../constants';

const defaultConfig = {
  onSuccess_: () => console.warn('default onSuccess!'),
  onError_: () => console.warn('default onError!'),
  onCancel_: () => console.warn('default onCancel!'),
};

export default class SetNamePopup extends PopupComponent {
  constructor(config) {
    super();
    this.config = Object.assign({}, defaultConfig, config);
    this.card = this.config.card;
    this.client = this.config.client;
    this.dom = {};
    this.helper = new Helper();

    if (!this.card) {
      console.warn('please give me an oxocard!');
    }

    const popupConfig = {
      id: 'popup_set_name',
      title: this.t('popupSetNameTitle'),
      initializedCallback: () => this._onInit(),
      disableBackgroundClick: this.config.forceRename,
      buttons: [
        {
          class: 'positive',
          shouldClose: true,
          text: this.t('popupSetNameRandom'),
          callback: () => this.setRandomName(),
        },
        {
          id: 'set_name_btn',
          class: 'positive',
          shouldClose: true,
          text: this.t('popupSetNameSave'),
          callback: () => this.setName(),
        },
      ],
    };

    if (!this.config.forceRename) {
      popupConfig.buttons.unshift({
        id: 'cancel',
        class: 'negative',
        shouldClose: true,
        text: this.t('defaultPopupNegativeButton'),
        callback: () => this.config.onCancel_(),
      });
    }

    this.popup = this.create(popupConfig);
    this.createContentElement('popup_set_name', template);
  }

  _onInit() {
    const content = document.getElementById('popup_set_name_popup_copy');
    this.dom = {
      hintMsg: content.children.set_name_hint,
      btn: document.getElementById('set_name_btn'),
      input: content.children.set_name_input_wrapper.children.set_name_input,
      msg: content.children.set_name_msg,
    };

    if (!this.config.forceRename) {
      this.dom.hintMsg.setAttribute('hidden', 'hidden');
    }

    this.dom.input.value = this.card.name;
    this.setInvalid('popupSetNameNotAvailable');
    this.checkName();
    this.dom.input.addEventListener('keyup', () => this.validateName());
    this.dom.input.addEventListener('change', () => this.helper.updateMaterialInput(this.dom.input));
  }

  async setName(newName) {
    const name_ = newName || this.dom.input.value.trim();
    if (!this.client) {
      this.config.onError_(ERROR_NO_HMAC_CLIENT);
      return;
    }
    const configReq = {
      path: SET_CARD_NAME_PATH,
      postData: { name: name_ },
      hmacId: this.client.hmacId,
      hmacSecret: this.client.hmacSecret,
    };
    const xhr = new net.Request();
    try {
      await xhr.makeRequest(configReq);
      this.card.name = name_;
      this.config.onSuccess_(this.card);
    } catch (e) {
      this.config.onError_(e);
    }
  }

  validateName() {
    const name = this.dom.input.value.trim();
    if (!oxocard.util.isNameValid(name)) {
      this.setInvalid('popupSetNameNotValid');
      return;
    }
    clearTimeout(this.timer);
    this.timer = setTimeout(() => this.checkName(), 300);
  }

  async setRandomName() {
    const xhr = new net.Request();
    const config = {
      path: GET_UNIQUE_NAME_PATH,
      hmacId: this.client.hmacId,
      hmacSecret: this.client.hmacSecret,
    };
    try {
      const res = await xhr.makeRequest(config);
      this.card.name = res.name;
      this.setName(res.name);
      // this.config.onSuccess_(this.card);
    } catch (e) {
      console.error(e);
      this.config.onError_(e);
    }
  }

  async checkName() {
    const name = this.dom.input.value.trim();
    let unique = false;
    try {
      unique = await oxocard.util.isNameUnique(name, this.client);
    } catch (e) {
      console.warn(e);
    }

    if (!oxocard.util.isNameValid(name)) {
      this.setInvalid('popupSetNameNotValid');
    } else if (unique) {
      this.setValid('popupSetNameAvailable');
    } else {
      this.setInvalid('popupSetNameNotAvailable');
    }
  }

  setInvalid(msg) {
    this.dom.msg.innerHTML = this.t(msg);
    this.dom.btn.setAttribute('disabled', 'disabled');
  }

  setValid(msg) {
    this.dom.msg.innerHTML = this.t(msg);
    this.dom.btn.removeAttribute('disabled');
  }
}
